export type GetAlgoliaRuleContextsParams = {
  ccShortName: string | null | undefined
  isLogged: boolean
  userCountry: string | null | undefined
}

const RULE_CONTEXTS = {
  LOGGING_STATUS: "is_logged",
  USER_COUNTRY: "user_country",
} as const

export const getAlgoliaRuleContexts = (params: GetAlgoliaRuleContextsParams): string[] => {
  const { ccShortName, isLogged = false, userCountry = "" } = params

  const userContext: string[] = []

  // Logging status
  userContext.push(`${RULE_CONTEXTS.LOGGING_STATUS}__${isLogged}`)

  // User country
  if (userCountry !== null && userCountry !== "") {
    userContext.push(`${RULE_CONTEXTS.USER_COUNTRY}__${userCountry}`)
  }

  // CC shortName (fallback to WWW if needed)
  userContext.push(`permalink__${ccShortName?.replaceAll(" ", "-").toLowerCase() || "www"}`)

  return userContext
}
